export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";